import { cn } from "@/lib/utils";

// className should be used at minimum to add a left margin. Prefer to keep spacing css in parent components.
export const OptionalLabel = ({
  className,
  sublabel,
}: {
  className: string;
  sublabel?: string;
}) => {
  const label = sublabel ? `optional - ${sublabel}` : "optional";
  return <span className={cn("text-xs italic", className)}>({label})</span>;
};
